module.exports = __webpack_public_path__ + "img/Weapon_78.1b1a27b5.png";